
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja/harian/add",
      function () {
        return require("private-next-pages/pengelolaan-kinerja/harian/add.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja/harian/add"])
      });
    }
  